import React from 'react';
import {
  Col,
  Badge,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';
import classnames from 'classnames';
import * as acessos from '../../../acessos.const.util';
import LaminaContainer from './tabs/lamina/lamina.container';
import './requisicao.congelacao.styles.css';
import JustificativaComponent from '../../../componentes/justificativa/justificativa.component';
import IntlMessage from '../../../helpers/intlMessage';

const RequisicaoCongelacaoPage = (props) => {
  return (
    (props.acessoPermitido(
      props.usuario,
      acessos.AdicionarBlocoseLaminasCongelacao
    ) ||
      props.acessoPermitido(props.usuario, acessos.Congelacao)) && (
      <React.Fragment>
        <JustificativaComponent
          isOpen={props.showModalJustificativa}
          toggle={props.toggleModalJustificativa}
          setJustificativa={props.setJustificativa}
          justificativa={props.justificativa}
          onClick={props.removerLaminaLista}
          title='Exclusão de Lâmina'
          label='Justificativa da Exclusão'
          btnText='Confirmar Exclusão'
          placeholder='Justificativa para a exclusão'
        />
        <div className='mv-requisicao-congelacao-container'>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: props.activeTab === '1' })}
                onClick={() => {
                  props.toggle('1');
                }}
              >
                {props.laminaText} {props.laminaId && ` (${props.laminaId})`}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ position: 'relative' }}
                className={classnames({ active: props.activeTab === '2' })}
                onClick={() => {
                  props.toggle('2');
                  props.resetEditar();
                }}
              >
                <IntlMessage id = "dashboards.examDetail.listBlades"/>{' '}
                <Badge className='count-laminas' style={{ right: -16 }}>
                  {props.listarLaminas.length}
                </Badge>
              </NavLink>
            </NavItem>
          </Nav>
          <br />
          <TabContent activeTab={props.activeTab}>
            <TabPane tabId='1'>
              <LaminaContainer
                laminaText={props.laminaText}
                laminaId={props.laminaId}
                laudo={props.laudo}
                nrExame={props.numeroExame}
              />
            </TabPane>
            <TabPane tabId='2'>
              <div className='responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th><IntlMessage id = "dashboards.examDetail.requester"/></th>
                      <th><IntlMessage id = "dashboards.examDetail.block"/></th>
                      <th><IntlMessage id = "dashboards.examDetail.blade"/></th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.listarLaminas &&
                      props.listarLaminas.length > 0 &&
                      props.listarLaminas.map((lamina, i) => {
                        return (
                          <tr key={lamina.idLaudoLamina}>
                            <td>{lamina.nomeMedico}</td>
                            <td>{lamina.bloco}</td>
                            <td>
                              {lamina.lamina + ` (${lamina.idLaudoLamina})`}
                            </td>
                            <td width={15}>
                              <Col>
                                {props.acessoPermitido(
                                  props.usuario,
                                  acessos.EditarBlocoseLaminasCongelacao
                                ) && (
                                  <Button
                                    className='editar-cassete'
                                    color='link'
                                    id={'editar_' + lamina.i}
                                    onClick={() =>
                                      props.editarLamina(lamina.idLaudoLamina)
                                    }
                                  >
                                    <i
                                      style={{
                                        fontSize: 13,
                                        float: 'left',
                                      }}
                                      className='fas fa-edit fa-2x'
                                    ></i>
                                    <UncontrolledTooltip
                                      placement='top'
                                      target={'editar_' + lamina.id}
                                    >
                                      Editar
                                    </UncontrolledTooltip>
                                  </Button>
                                )}
                              </Col>
                            </td>
                            <td>
                              <Col>
                                {props.acessoPermitido(
                                  props.usuario,
                                  acessos.ApagarBlocoseLaminasCongelacao
                                ) && (
                                  <Button
                                    className='editar-cassete'
                                    color='link'
                                    id={'excluir_' + lamina.i}
                                    onClick={() =>
                                      props.apagarLaminaJustificativa(
                                        lamina.idLaudoLamina
                                      )
                                    }
                                  >
                                    <i
                                      style={{
                                        fontSize: 13,
                                        float: 'right',
                                      }}
                                      className='fas fa-trash fa-2x'
                                    ></i>
                                    <UncontrolledTooltip
                                      placement='top'
                                      target={'excluir_' + lamina.id}
                                    >
                                      Excluir
                                    </UncontrolledTooltip>
                                  </Button>
                                )}
                              </Col>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
              {/* </div> */}
            </TabPane>
          </TabContent>
        </div>
      </React.Fragment>
    )
  );
};

export default RequisicaoCongelacaoPage;



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/requisicao.congelacao.page.js